import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Inject, Output, ViewChild, NgModule } from '@angular/core';
import * as i2 from '@upr-web-primer/locale';
import { LocaleModule } from '@upr-web-primer/locale';
import { WINDOW, WindowModule } from '@upr-web-primer/window';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
const _c0 = ["recaptcha"];
class GoogleRecaptchaService {
  constructor() {
    this.reset$ = new Subject();
  }
  reset() {
    this.reset$.next(true);
  }
  static {
    this.ɵfac = function GoogleRecaptchaService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GoogleRecaptchaService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GoogleRecaptchaService,
      factory: GoogleRecaptchaService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GoogleRecaptchaService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
let count = 0;
class GoogleRecaptchaComponent {
  constructor(zone, captchaService, localeService, window, config) {
    this.zone = zone;
    this.captchaService = captchaService;
    this.localeService = localeService;
    this.window = window;
    this.config = config;
    this.response = new EventEmitter();
    this.id = count++;
    this.language = this.localeService.getFromStorage().language;
    this.captchaService.reset$.subscribe(() => {
      this.reset();
    });
  }
  ngOnInit() {
    document.getElementById('grecaptcha') ? this.render() : this.loadCaptchaScript();
  }
  loadCaptchaScript() {
    this.window.recaptchaCallback = () => {
      this.render();
    };
    const script = document.createElement('script');
    const language = this.language ? `&hl=${this.language}` : '';
    script.src = `${this.config.apiUrl}?onload=recaptchaCallback&render=explicit${language}`;
    script.async = true;
    script.defer = true;
    script.id = this.recaptcha.nativeElement;
    document.body.appendChild(script);
  }
  render() {
    if (grecaptcha && typeof grecaptcha.render === 'function') {
      this.recaptchaId = grecaptcha.render(this.recaptcha.nativeElement.id, {
        sitekey: this.config.siteKey,
        callback: res => {
          this.zone.run(() => {
            this.response.emit(res);
          });
        },
        'expired-callback': () => {
          this.reset();
        }
      });
    } else {
      setTimeout(() => {
        this.render();
      }, 5000);
    }
  }
  ngOnDestroy() {
    this.zone.run(() => {
      if (grecaptcha) {
        grecaptcha.reset(this.recaptchaId);
      }
    });
  }
  reset() {
    this.zone.run(() => {
      if (grecaptcha) {
        grecaptcha.reset(this.recaptchaId);
        this.response.emit('');
      }
    });
  }
  static {
    this.ɵfac = function GoogleRecaptchaComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GoogleRecaptchaComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(GoogleRecaptchaService), i0.ɵɵdirectiveInject(i2.LocaleService), i0.ɵɵdirectiveInject(WINDOW), i0.ɵɵdirectiveInject('RecaptchaConfig'));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GoogleRecaptchaComponent,
      selectors: [["upr-google-recaptcha"]],
      viewQuery: function GoogleRecaptchaComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.recaptcha = _t.first);
        }
      },
      outputs: {
        response: "response"
      },
      standalone: false,
      decls: 2,
      vars: 2,
      consts: [["recaptcha", ""], [1, "g-recaptcha", 3, "id"]],
      template: function GoogleRecaptchaComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", 1, 0);
        }
        if (rf & 2) {
          i0.ɵɵpropertyInterpolate1("id", "google-recaptcha-", ctx.id, "");
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GoogleRecaptchaComponent, [{
    type: Component,
    args: [{
      selector: 'upr-google-recaptcha',
      standalone: false,
      template: "<div #recaptcha class=\"g-recaptcha\" id=\"google-recaptcha-{{ id }}\"></div>\r\n"
    }]
  }], () => [{
    type: i0.NgZone
  }, {
    type: GoogleRecaptchaService
  }, {
    type: i2.LocaleService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [WINDOW]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['RecaptchaConfig']
    }]
  }], {
    response: [{
      type: Output
    }],
    recaptcha: [{
      type: ViewChild,
      args: ['recaptcha', {
        static: true
      }]
    }]
  });
})();
class GoogleRecaptchaModule {
  static {
    this.ɵfac = function GoogleRecaptchaModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GoogleRecaptchaModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GoogleRecaptchaModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, WindowModule, LocaleModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GoogleRecaptchaModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, WindowModule, LocaleModule],
      declarations: [GoogleRecaptchaComponent],
      exports: [GoogleRecaptchaComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of google-recaptcha
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GoogleRecaptchaComponent, GoogleRecaptchaModule, GoogleRecaptchaService };
